import { SET_CHAT_QUEUES } from '@/store/mutation-types';

const mutations = {
  [SET_CHAT_QUEUES](state, queues) {
    state.queues = queues;
  },
};

export default mutations;
